<template>
  <assistant-detail></assistant-detail>
</template>

<script>
import AssistantDetail from '../components/AssistantDetail.vue'
export default {
  name: 'AssistantDetailView',
  components: {
    AssistantDetail
  }
}
</script>
